<app-scaffold
  icon="streamline:single-neutral-actions-block"
  [title]="'ERROR.FORBIDDEN.TITLE' | translate"
  [content]="'ERROR.FORBIDDEN.CONTENT' | translate"
  [actionLabel]="'ERROR.GO_HOME' | translate"
  actionLink="/"
>
</app-scaffold>
